import { type ComponentProps, type ReactNode } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import styles from './Accordion.module.css';

interface AccordionProps extends ComponentProps<'details'> {
  className?: string;
  header: ReactNode;
  headerClassName?: string;
}

export default function Accordion({ className, children, header, ...props }: AccordionProps) {
  return (
    <details
      className={clsx(styles.wrapper, className)}
      {...props}
    >
      <summary className={styles.closeElement}>
        <div className={styles.header}>{header}</div>
        <ChevronDownIcon
          aria-hidden="true"
          className={styles.icon}
        />
      </summary>
      {children}
    </details>
  );
}
